import './App.css';
import Button from '@mui/joy/Button';
import { Grid } from '@mui/joy';

function Home() {
    return(
      <Grid container sx={{ flexGrow: 1 }} className="App-header">
        <Grid xs={4}>
        </Grid>
        <Grid xs={4}>
          <br />
          <br />
          <div className="not-connected-home">
            Please install MetaMask to use our app.<br />
            <a href="https://www.metamask.io/download" target="_blank" rel="noreferrer"><Button>Download MetaMask</Button></a>            
          </div>
        </Grid>
        <Grid xs={4}>
        </Grid>
      </Grid>
    )
}

export default Home;